import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, isRef as _isRef, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search-results-header" }

import _ from 'lodash';
import {ref, onMounted, computed} from 'vue';
import SearchBar from 'components/global-common/SearchBar.vue';
import DropDown from 'components/global-common/DropDown.vue';
import {CodeBookDropdownOptions, useSearchStore} from 'stores/search-store';
import {storeToRefs} from 'pinia';
import {useGrouperStore} from 'stores/grouper-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResultsHeader',
  setup(__props) {

const searchStore = useSearchStore();
const {bookSelected, modeSelected, searchText} = storeToRefs(searchStore);
const { readOnly } = storeToRefs(useGrouperStore());

const books = ref(bookSelected);
const mode = ref(modeSelected);

onMounted(() => {
  searchStore.fetchUpdatedHistory();
});

function updateModeSelected() {
  searchStore.setModeSelected(mode.value == 'table' ? mode.value : 'index');
}

function bookChanged(){
  searchStore.setBookSelected(books.value);
}

async function submitSearch(text: string, findAll: boolean): Promise<object[]> {
  return _.defaultTo(await searchStore.getCodebookTermSearchAndInitialDetails('' + text, findAll), []);
}

const disableButtonToggle= computed(() => {
  return !searchStore.isProceduresBookSelected
});


return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn_toggle = _resolveComponent("q-btn-toggle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DropDown, {
      modelValue: books.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((books).value = $event)),
        bookChanged
      ],
      options: _unref(CodeBookDropdownOptions),
      label: "Book",
      "iodine-class-name": "book",
      disabled: _unref(readOnly),
      "popup-content-class": "search-book-dropdown"
    }, null, 8, ["modelValue", "options", "disabled"]),
    _createVNode(SearchBar, {
      modelValue: _unref(searchText),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(searchText) ? (searchText).value = $event : null)),
      search: submitSearch,
      "should-rerender": true,
      "class-name": "search",
      "show-results-menu": false,
      disable: _unref(searchStore).isTableModeSelected || _unref(readOnly),
      "auto-search": false,
      showSearchHistory: true,
      showFindAll: true,
      searchHistory: _unref(searchStore).getSearchHistory
    }, null, 8, ["modelValue", "disable", "searchHistory"]),
    _createVNode(_component_q_btn_toggle, {
      modelValue: mode.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((mode).value = $event)),
      unelevated: "",
      "no-caps": "",
      "toggle-color": "ioaccent",
      "toggle-text-color": "ioaccent",
      disable: disableButtonToggle.value || _unref(readOnly),
      options: [
            {value: 'index', icon: 'fa-regular fa-list-tree', slot: 'index' },
            {value: 'table', icon: 'fa-regular fa-table-columns', slot: 'table'}
            ],
      class: "iodine-toggle-button",
      onClick: updateModeSelected
    }, {
      index: _withCtx(() => [
        (mode.value == 'table')
          ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
              default: _withCtx(() => [
                _createTextVNode("Switch to Index View")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      table: _withCtx(() => [
        (mode.value == 'index')
          ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
              default: _withCtx(() => [
                _createTextVNode("Switch to Table View")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        (disableButtonToggle.value)
          ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
              default: _withCtx(() => [
                _createTextVNode(" Changing the view is only available when procedure book is selected ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "disable"])
  ]))
}
}

})